import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import About from './components/About';
import Contact from './components/Contact';
import Blog from './components/Blog';
import Footer from './components/Footer';

const LOCAL_BUSINESS_LD = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#localbusiness`,
  name: 'CAF Patronato Chiari - Navoni Stefania',
  description:
    'CAF e Patronato a Chiari (Brescia): dichiarazioni fiscali 730, NASPI, pensioni, invalidità, permessi di soggiorno, cittadinanza, successioni e contratti di affitto. 20+ anni di esperienza.',
  url: import.meta.env.VITE_SITE_URL ?? 'https://example.com',
  telephone: '+39-030-712-316',
  email: 'stefania.navoni@enasc.eu',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Via Marengo, 6',
    addressLocality: 'Chiari',
    addressRegion: 'BS',
    postalCode: '25032',
    addressCountry: 'IT',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 45.5317,
    longitude: 9.9267,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '12:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '15:00',
      closes: '19:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Saturday'],
      opens: '09:00',
      closes: '12:00',
    },
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Servizi CAF e Patronato',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Dichiarazione dei redditi 730' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'NASPI – Indennità di disoccupazione' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Pensioni' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Invalidità civile' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Permessi di soggiorno' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Richiesta di cittadinanza' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Dichiarazione di successione' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Registrazione contratti di affitto' } },
    ],
  },
};

const FAQ_LD = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Quali servizi CAF offrite a Chiari?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Offriamo dichiarazione dei redditi 730, dichiarazione di successione, registrazione contratti di affitto e ISEE a Chiari (Brescia).',
      },
    },
    {
      '@type': 'Question',
      name: 'Come posso richiedere la NASPI tramite il vostro patronato?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Potete contattarci telefonicamente al 030 712 316 o via email a stefania.navoni@enasc.eu per avviare la pratica NASPI. Il nostro patronato a Chiari gestisce l\'intera procedura.',
      },
    },
    {
      '@type': 'Question',
      name: 'Gestite pratiche per permessi di soggiorno e cittadinanza?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sì, offriamo assistenza completa per permessi di soggiorno e richiesta di cittadinanza italiana presso il nostro ufficio di Chiari, Brescia.',
      },
    },
    {
      '@type': 'Question',
      name: 'Quali sono gli orari di apertura del CAF Patronato di Chiari?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Siamo aperti dal lunedì al venerdì dalle 9:00 alle 12:00 e dalle 15:00 alle 19:00, e il sabato dalle 9:00 alle 12:00. Siamo in Via Marengo, 6 a Chiari (BS).',
      },
    },
  ],
};

export default function HomePage() {
  useEffect(() => {
    const injectLd = (id: string, data: object) => {
      let el = document.getElementById(id);
      if (!el) {
        el = document.createElement('script');
        el.id = id;
        (el as HTMLScriptElement).type = 'application/ld+json';
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(data);
    };

    injectLd('ld-local-business', LOCAL_BUSINESS_LD);
    injectLd('ld-faq', FAQ_LD);

    return () => {
      ['ld-local-business', 'ld-faq'].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <Portfolio />
      <About />
      <Contact />
      <Blog />
      <Footer />
    </div>
  );
}
